import React, { ReactElement } from 'react';
import { Headline } from '..';
import './style.css';

export default function FeatureGridHeader(): ReactElement {
  return (
    <section className="feature-grid-header relative mt-16 flex justify-center p-4">
      <Headline level="1" color="blue" className="absolute z-10 text-center">
        Come for the features,
        <br />
        stay for the magic
      </Headline>
      <img
        src="/homepage__features-magic-sparkle.svg"
        alt=""
        role="presentation"
        className="h-[77px] w-[60px] -translate-y-4 translate-x-[480px]"
      />

      <svg
        width="365"
        height="59"
        viewBox="0 0 365 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="translate-x-[34px] translate-y-[62px]">
        <path
          d="M0.5 58.8569L2.19636 6.40476L364.5 0.856934L362.942 58.8569H0.5Z"
          fill="var(--color-base-pink)"
        />
      </svg>
    </section>
  );
}
